
import { useState } from "react";
import { useQuery } from "@tanstack/react-query";
import { startDescuentosXLote, startDescuentosXTipo } from "../../../services";







export const useDescuentosXLote = (id) => {
    const descuentosXLoteQuery = useQuery({
        queryKey: ['descuentos-xlote', id], 
        queryFn: () => startDescuentosXLote(id),
    });

    return {
        descuentosXLoteQuery,
    }
}





export const useDescuentosXTipo = ({id, descuento}) => {
    
    const [page, setPage] = useState(0);
    const [inicio, setInicio] = useState('');
    const [final, setFinal] = useState('');

    const desucentoTipoQuery = useQuery({
        queryKey: ['descuento-tipo', { page, descuento, id, inicio, final }], 
        queryFn: () => startDescuentosXTipo({ page, descuento, id, inicio, final }),
    });
    

    const chagePage = (num) => {
        setPage(num - 1);
    }

    const chageInicio = (valor) => {
        setPage(0);
        setInicio(valor)
    }

    const chageFinal = (valor) => {
        setPage(0);
        setFinal(valor)
    }

    
    return {
        // Estados
        page,
        inicio,
        final,

        // Metodos
        chageInicio,
        chageFinal,
        chagePage,
        desucentoTipoQuery,
    }
}


